export default "__VITE_ASSET__8be771d5__"